import { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { Box, Grid, Stack, Typography } from "@mui/material"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import AddIcon from '@mui/icons-material/Add';
// import CloseIcon from '@mui/icons-material/Close';
// import moment from "moment";
import axios from "axios";
import BaseButton from "../BaseButton"
// import BaseCheckbox from "../BaseCheckbox";
// import BaseSwitch from "../BaseSwitch";
import BaseInput from "../BaseInput";
// import BaseColorText from "../BaseColorText";
import BaseImage from "../BaseImage";
import BaseSelect from "../BaseSelect";
import BaseTextareaAutosize from "../BaseTextareaAutosize";
// import BirthInputGroup from "../BirthInputGroup";
// import MedicationSelectForm from "../MedicationSelectForm";
// import FamilyGroupCheckboxList from "../FamilyGroupCheckboxList";
import { STATES, TITLE_OPTIONS } from "../../constants";
import { validationsProfileEditFormSchema } from "../../validations/validationSignUpSchema";
import { showErrorToast, showToast } from "../../utils/toast";
import { UserSetStaffProfile, UploadUserAvatar, VerifyUpload } from "../../apollo-client/api-query";
import { useMutation } from "@apollo/client";
import { refetchMe } from '../../store';
import { formatPhoneNumber } from "../../hooks/use-format-phone-number";

const ProfileEditForm = ({ sx, onClose }) => {
  const dispatch = useDispatch()
  const auth = useSelector(state => state.auth)
  // const reports = useSelector(state => state.reports)
  // const medicationData = useMemo(() => reports?.find(item => item.name === 'Medications'), [reports])
  // const userMedications = useMemo(() => auth?.medications, [auth])

  // const [setMedications] = useMutation(UserSetMedications, {fetchPolicy: 'network-only'})

  const [updateUser, { loading }] = useMutation(UserSetStaffProfile)
  const [uploadUserAvatar] = useMutation(UploadUserAvatar)
  const [verifyUpload] = useMutation(VerifyUpload)

  // const [selectedGender, setSelectedGender] = useState(GENDERS_ENUM.MALE)
  // const [showMedicationSearchInput, setShowMedicationSearchInput] = useState(false)
  // const [currentMedications, setCurrentMedications] = useState([])

  // const [file, setFile] = useState(null);
  // const [fileDataURL, setFileDataURL] = useState(null);
  const [uploadedAvatarUrl, setUploadedAvatarUrl] = useState(null)
  const [isUploading, setIsUploading] = useState(false)
  const [isOpenStateDropdown, setIsOpenStateDropdown] = useState(false)
  const [stateList, setStateList] = useState(STATES)

  const handleChangeState = (e) => {
    handleChange(e)
    const stateArray = STATES.filter(item => item.includes(e.target.value))
    setStateList(stateArray)

    if (e.target.value) {
      setIsOpenStateDropdown(true)
    } else {
      setIsOpenStateDropdown(false)
    }
    if (stateArray.length === 0) setIsOpenStateDropdown(false)
  }

  const handleClickState = (state) => {
    setIsOpenStateDropdown(false)
    setValues({
      ...values,
      clinicAddressState: state
    })
  }

  // useEffect(() => setCurrentMedications(userMedications), [userMedications])

  const handleUploadFile = (e) => {
    setIsUploading(true)
    const [file] = e.target.files

    // if (!file.type.match(imageMimeType)) {
    //   alert("Image mime type is not valid");
    //   return;
    // }
    // setFile(file);
    // setFileDataURL(URL.createObjectURL(e.target.files[0]))

    uploadUserAvatar({
      variables: {
        uploadInput: {
          filename: file?.name,
          mimeType: file?.type,
          size: file?.size
        }
      }
    })
    .then(async ({ data }) => {
      const headersArray = data?.userUploadAvatar?.headers.map((({ key, value }) => ({ [key]: value }))),
      headersObj = Object.assign({}, ...headersArray)

      const headers = {
        'X-Requested-With': '*',
        'Access-Control-Allow-Headers': 'Content-Type,X-Amz-Date,Authorization,X-Api-Key,x-requested-with',
        'Access-Control-Allow-Origin': '*',
        ...headersObj
      }
      
      // upload file to presigned aws s3 bucket
      await axios({
        method: 'PUT',
        url: data?.userUploadAvatar?.url,
        data: file,
        headers
      })
      
      await verifyUpload({
        variables: {
          uploadId: data?.userUploadAvatar?.id
        }
      })
      setUploadedAvatarUrl(`https://dev.descendantsdna.com/public_files/${data?.userUploadAvatar?.id}`)
      dispatch(
        refetchMe(true)
      )
    })
    .catch(error => {
      showErrorToast({
        message: error?.message
      })
    })
    .finally(() => {
      setIsUploading(false)
    })
  }

  const { errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values, setValues } =
    useFormik({
      validateOnBlur: true,
      initialValues: {
        phone: '',
        npi: '',
        title: '',
        specialty: '',
        bio: '',
        clinicAddressLine1: '',
        clinicAddressLine2: null,
        clinicName: '',
        clinicAddressCity: '',
        clinicAddressState: '',
        clinicAddressPostalCode: '',
        clinicAddressPostalCountry: "USA"
      },
      validationSchema: validationsProfileEditFormSchema,
      onSubmit: (values, { setSubmitting }) => {
        setSubmitting(true);
        updateUser({
          variables: {
            staffProfile: {
              // id: auth?.id,
              phone: `+1 ${values.phone}` || null,
              npi: values.npi || null,
              title: values.title || null,
              specialty: values.specialty || null,
              bio: values.bio || null,
              clinicAddressLine1: values.clinicAddressLine1 || null,
              clinicAddressLine2: null,
              clinicName: values.clinicName || null,
              clinicAddressCity: values.clinicAddressCity || null,
              clinicAddressState: values.clinicAddressState || null,
              clinicAddressPostalCode: values.clinicAddressPostalCode || null,
              clinicAddressPostalCountry: "USA"
            }
          }
        })
        .then(() => {
          dispatch(
            refetchMe(true)
          )
          onClose()
          return showToast({
            message: 'Updated your profile'
          })
        })
        .catch((error) => {
          return showErrorToast({
            message: error.message
          })
        })
        .finally(() => {
          setSubmitting(false)
        })
      },
    });

  useMemo(() => {
    if (auth) {
      // const dateOfBirth = moment(auth.dateOfBirth, 'YYYY/MM/DD')
      setValues({
        // firstName: auth.firstName || '',
        // lastName: auth.lastName || '',
        // email: auth.email || '',
        // birthMonth: dateOfBirth.format('MM'),
        // birthDate: dateOfBirth.format('DD'),
        // birthYear: dateOfBirth.format('YYYY'),
        phone: formatPhoneNumber(auth?.staffProfile?.phone).replace('+1 ', '') || '',
        npi: auth?.staffProfile?.npi || '',
        title: auth?.staffProfile?.title || '',
        specialty: auth?.staffProfile?.specialty || '',
        bio: auth?.staffProfile?.bio || '',
        clinicAddressLine1: auth?.staffProfile?.clinicAddressLine1 || '',
        clinicName: auth?.staffProfile?.clinicName || '',
        clinicAddressCity: auth?.staffProfile?.clinicAddressCity || '',
        clinicAddressState: auth?.staffProfile?.clinicAddressState || '',
        clinicAddressPostalCode: auth?.staffProfile?.clinicAddressPostalCode || '',
      })
      // setSelectedGender(auth?.sex)
      setUploadedAvatarUrl(auth?.avatarUrl)
    }
  }, [auth, setValues])

  const handleChangePhone = (e) => {
    const value = formatPhoneNumber(e.target.value).replace('+1 ', '')
    setValues({
      ...values,
      phone: value
    })
  }

  // const handleRemoveCurrentMedication = (medication) => {
  //   const selectedMedications = currentMedications.filter(item => medication.name !== item.name)
  //   setCurrentMedications(selectedMedications)

  //   setMedications({
  //     variables: {
  //       medications: selectedMedications.map(item => ({ name: item.name, strength: item.strength }))
  //     }
  //   }).catch(error => {
  //     showErrorToast({
  //       message: error.message
  //     })
  //   }).then(({ data }) => {
  //     dispatch(refetchMe(true))
  //   })
  // }

  return (
    <Box
      sx={{
        width: '100%'
      }}
    >
      <form onSubmit={handleSubmit}>
        <Box
          className='notification-dropdown-scroll'
          sx={{
            width: '100%',
            height: { xs: '50vh', md: '60vh' },
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
            padding: '10px 10px 16px 16px',
            mt: '20px',
            ...sx
          }}
        >
          <Box
            sx={{
              width: '100%',
              borderRadius: '8px',
              padding: '16px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              boxShadow: '0px 2px 10px 0px #5B87EF33'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                borderBottom: '1px solid',
                borderColor: 'primary.mediumGray',
                pb: '16px'
              }}
            >
              <Typography
                variant="h4"
              >
                Your Profile
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                my: '16px'
              }}
            >
              <BaseImage
                sx={{
                  width: '80px',
                  minWidth: '80px',
                  height: '80px',
                }}
                sximage={{
                  borderRadius: '50%',
                  objectFit: 'cover'
                }}
                src={uploadedAvatarUrl || '//ssl.gstatic.com/accounts/ui/avatar_2x.png'}
                alt='profile-avatar'
              />
              <BaseButton
                buttonType={'default'}
                sx={{
                  maxWidth: '200px',
                  height: '31px',
                  ml: '16px'
                }}
                loading={isUploading}
              >
                <label htmlFor="upload-image">
                  <Typography variant="subText">
                    Change profile picture
                  </Typography>
                </label>
                <input
                  type="file"
                  id="upload-image"
                  onChange={handleUploadFile}
                  accept="image/*"
                  style={{
                    display: 'none'
                  }}
                />
              </BaseButton>
            </Box>
            <Stack direction={'column'} spacing={'10px'}>
              <BaseInput
                fullWidth
                label='Your name'
                name='firstName'
                type='text'
                placeholder='Enter your first name'
                value={`${auth?.firstName} ${auth?.lastName}` || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={touched.firstName ? errors.firstName : ""}
                error={touched.firstName && Boolean(errors.firstName)}
                required
                disabled
              />
              <BaseInput
                fullWidth
                label='Email'
                name='email'
                type='email'
                placeholder='Enter your email'
                value={auth?.email || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={touched.email ? errors.email : ""}
                error={touched.email && Boolean(errors.email)}
                required
                disabled
              />
              {/* <BaseInput
                fullWidth
                label='Last name'
                name='lastName'
                type='text'
                placeholder='Enter your last name'
                value={values.lastName || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={touched.lastName ? errors.lastName : ""}
                error={touched.lastName && Boolean(errors.lastName)}
                required
              /> */}
              <Box
                sx={{
                  borderRadius: '5px',
                  padding: '12px',
                  bgcolor: 'primary.lightGreen1',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <Typography variant="h4" color="primary.darkGray">
                  NPI Number
                </Typography>
                <BaseInput
                  sx={{
                    width: '160px'
                  }}
                  label=''
                  name='npi'
                  type='text'
                  placeholder='Enter npi'
                  value={values.npi || ''}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  helperText={touched.npi ? errors.npi : ""}
                  error={touched.npi && Boolean(errors.npi)}
                  required
                />
              </Box>
              <BaseSelect
                label='Your Title'
                name='title'
                value={values.title || ''}
                options={TITLE_OPTIONS}
                onChangeSelect={(value) => setValues({
                  ...values,
                  title: value
                })}
                error={errors.title}
                required
              />
              <BaseInput
                sx={{
                  mt: '16px',
                }}
                fullWidth
                label='Specialty'
                name='specialty'
                type='text'
                placeholder='Specialty'
                value={values.specialty || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={touched.specialty ? errors.specialty : ""}
                error={touched.specialty && Boolean(errors.specialty)}
              />
              <BaseTextareaAutosize
                sx={{
                  mt: '16px',
                }}
                fullWidth
                label='Bio'
                name='bio'
                id='bio'
                placeholder='Bio'
                maxLength={300}
                value={values.bio || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.bio}
              />
            </Stack>
              {/* <BirthInputGroup
                sx={{
                  mt: '8px'
                }}
                values={values}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
              /> */}
              {/* <Box sx={{ mt: '8px' }}>
                <Typography 
                  sx={{
                    fontWeight: 600,
                    fontSize: '15px',
                    color: '#46545F'
                  }}
                >
                  Assigned sex at birth <BaseColorText color='#E73E3E'>*</BaseColorText>
                </Typography>
                <BaseSwitch
                  sx={{ mt: '4px' }}
                  selected={selectedGender}
                  onChange={(value) => setSelectedGender(value)}
                  options={GENDERS}
                  activeColor={selectedGender === 'MALE' ? '#39B195' : '#E73E3E'}
                />
              </Box> */}
              {/* <BaseButton
                type="submit"
                variant='contained'
                buttonType='primary'
                width={{ xs: '100%', md: '160px' }}
                sx={{
                  // position: 'absolute',
                  // bottom: '16px',
                  // left: '16px'
                }}
                loading={isSubmitting}
              >
                <Typography
                  variant="body"
                  color="white"
                >
                  Save
                </Typography>
              </BaseButton>
            </form> */}
          </Box>
          <Box
            sx={{
              width: '100%',
              borderRadius: '8px',
              padding: '16px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              boxShadow: '0px 2px 10px 0px #5B87EF33',
              mt: '24px'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                borderBottom: '1px solid',
                borderColor: 'primary.mediumGray',
                pb: '16px'
              }}
            >
              <Typography
                variant="h4"
              >
                Clinic information
              </Typography>
            </Box>
            <Box
              sx={{
                mt: '16px'
              }}
            >
            <Typography variant="h4" color="primary.mainBlue">
              Clinic phone
            </Typography>
            <Grid container spacing={'16px'}>
              <Grid item xs={12} md={4}>
                <BaseInput
                  fullWidth
                  label='Area code'
                  name='areaCode'
                  type='text'
                  placeholder='+1'
                  value={'+1'}
                  onChange={handleChangePhone}
                  onBlur={handleBlur}
                  // helperText={touched.phone ? errors.phone : ""}
                  // error={touched.phone && Boolean(errors.phone)}
                  required
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <BaseInput
                  fullWidth
                  label='Phone number'
                  name='phone'
                  type='text'
                  placeholder='Phone'
                  value={values.phone || ''}
                  onChange={handleChangePhone}
                  onBlur={handleBlur}
                  helperText={touched.phone ? errors.phone : ""}
                  error={touched.phone && Boolean(errors.phone)}
                  required
                />
              </Grid>
            </Grid>
            </Box>
            <Box
              sx={{
                mt: '16px'
              }}
            >
              <Typography variant="h4" color="primary.mainBlue">
                Clinic Address
              </Typography>
              <Grid container spacing={'16px'}>
                <Grid item xs={12}>
                  <BaseInput
                    fullWidth
                    label='Address line'
                    name='clinicAddressLine1'
                    type='text'
                    placeholder='Type address'
                    value={values.clinicAddressLine1 || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={touched.clinicAddressLine1 ? errors.clinicAddressLine1 : ""}
                    error={touched.clinicAddressLine1 && Boolean(errors.clinicAddressLine1)}
                    required
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <BaseInput
                    fullWidth
                    label='City'
                    name='clinicAddressCity'
                    type='text'
                    placeholder='City'
                    value={values.clinicAddressCity || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={touched.clinicAddressCity ? errors.clinicAddressCity : ""}
                    error={touched.clinicAddressCity && Boolean(errors.clinicAddressCity)}
                    required
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box
                    sx={{
                      position: 'relative'
                    }}
                  >
                    <BaseInput
                      fullWidth
                      label='State'
                      name='clinicAddressState'
                      type='text'
                      placeholder='State'
                      value={values.clinicAddressState || ''}
                      onChange={handleChangeState}
                      onFocus={() => setIsOpenStateDropdown(true)}
                      onBlur={handleBlur}
                      helperText={touched.clinicAddressState ? errors.clinicAddressState : ""}
                      error={touched.clinicAddressState && Boolean(errors.clinicAddressState)}
                      required
                      inputStyles={{
                        paddingRight: '10px',
                        color: '#46545F'
                      }}
                    />
                    <ExpandMoreIcon
                      sx={{
                        position: 'absolute',
                        right: '1px',
                        top: '36px',
                        color: 'primary.mediumGray',
                        zIndex: 10,
                        cursor: 'pointer'
                      }}
                      onClick={() => setIsOpenStateDropdown(!isOpenStateDropdown)}
                    />
                    {isOpenStateDropdown && (
                      <Box
                        className="scroll-lightGray"
                        sx={{
                          position: 'absolute',
                          top: '80px',
                          left: 0,
                          minWidth: { xs: '100%', md: '200px' },
                          height: '300px',
                          overflowY: 'auto',
                          bgcolor: 'white',
                          borderRadius: '8px',
                          pr: '1px',
                          border: '1px solid',
                          borderColor: 'primary.mainBlue',
                          padding: '8px 2px 8px 8px',
                          boxShadow: '0px 2px 10px 0px #5B87EF33',
                          zIndex: 10
                        }}
                      >
                        {stateList.map((stateVal => (
                          <Box
                            key={stateVal}
                            sx={{
                              borderRadius: '4px',
                              padding: '8px 16px',
                              cursor: 'pointer',
                              bgcolor: values.clinicAddressState === stateVal ? 'primary.lightBlue' : 'white',
                              '&:hover': {
                                bgcolor: 'primary.lightBlue'
                              }
                            }}
                            onClick={() => handleClickState(stateVal)}
                          >
                            <Typography variant="body" color="primary.darkGray">
                              {stateVal}
                            </Typography>
                          </Box>
                        )))}
                      </Box>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <BaseInput
                    fullWidth
                    label='Zip Code'
                    name='clinicAddressPostalCode'
                    type='text'
                    placeholder='Zip'
                    value={values.clinicAddressPostalCode || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={touched.clinicAddressPostalCode ? errors.clinicAddressPostalCode : ""}
                    error={touched.clinicAddressPostalCode && Boolean(errors.clinicAddressPostalCode)}
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <BaseInput
                    fullWidth
                    label='Clinic name (optional)'
                    name='clinicName'
                    type='text'
                    placeholder='Type name'
                    value={values.clinicName || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={touched.clinicName ? errors.clinicName : ""}
                    error={touched.clinicName && Boolean(errors.clinicName)}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>
          {/* <Box
            sx={{
              width: '100%',
              borderRadius: '8px',
              padding: '16px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              boxShadow: '0px 2px 10px 0px #5B87EF33',
              mt: '24px'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                borderBottom: '1px solid',
                borderColor: 'primary.mediumGray',
                pb: '16px'
              }}
            >
              <Typography
                variant="h4"
              >
                Reports
              </Typography>
              <Typography variant="subText">
                Select reports that you would not want to set for the public (family members) to view without the administrator’s permission.
              </Typography>
            </Box>
            <Grid container spacing={'0px'}>
              {reports.map((item => (
                <Grid item xs={12} key={item.name}>
                  <Box
                    sx={{
                      padding: '0px 16px',
                      borderRadius: '8px',
                      bgcolor: 'background.default'
                    }}
                  >
                    <BaseCheckbox
                      label={
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center'
                          }}
                        >
                          <BaseImage 
                            src={item.icon}
                            sx={{
                              width: '24px',
                              height: '24px',
                              mr: '12px'
                            }}
                            alt={item.name}
                          />
                          <Typography variant="body">
                            {item.name}
                          </Typography>
                        </Box>
                      }
                    />
                  </Box>
                </Grid>
              )))}
            </Grid>
          </Box> */}
          {/* <Box
            sx={{
              width: '100%',
              borderRadius: '8px',
              padding: '16px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              boxShadow: '0px 2px 10px 0px #5B87EF33',
              mt: '24px'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                borderBottom: '1px solid',
                borderColor: 'primary.mediumGray',
                pb: '16px'
              }}
            >
              <Typography
                variant="h4"
              >
                Your current medication
              </Typography>
              <Typography variant="subText">
                *Unavailable to family members without your permission
              </Typography>
            </Box>
            <Box
              sx={{
                mt: '16px'
              }}
            >
              <Grid container spacing={'8px'}>
                {currentMedications.map((item => (
                  <Grid item xs={12} key={item.name}>
                    <Box
                      sx={{
                        padding: '12px',
                        borderRadius: '5px',
                        backgroundColor: 'primary.lightBlue',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <CloseIcon 
                          sx={{
                            fontSize: '24px',
                            color: 'primary.black',
                            mr: '8px',
                            cursor: 'pointer'
                          }}
                          onClick={() => handleRemoveCurrentMedication(item)}
                        />
                        <Typography variant="body">{item.name}</Typography>
                      </Box>
                      <Typography variant="body" textAlign={'right'}>{item.strength}</Typography>
                    </Box>
                  </Grid>
                )))}
              </Grid>
              {!showMedicationSearchInput ? (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    mt: '16px',
                    cursor: 'pointer'
                  }}
                  onClick={() => setShowMedicationSearchInput(true)}
                >
                  <AddIcon 
                    sx={{
                      fontSize: '20px',
                      color: 'primary.black',
                      mr: '4px'
                    }}
                  />
                  <Typography variant="body">
                    Add new medication
                  </Typography>
                </Box>
              ) : (
                <Box
                  sx={{
                    mt: '16px'
                  }}
                >
                  <MedicationSelectForm
                    currentMedications={currentMedications}
                    setCurrentMedications={setCurrentMedications}
                    setShowMedicationSearchInput={setShowMedicationSearchInput}
                  />
                </Box>
              )}
            </Box>
          </Box> */}
          {/* <Box
            sx={{
              width: '100%',
              borderRadius: '8px',
              padding: '16px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              boxShadow: '0px 2px 10px 0px #5B87EF33',
              mt: '24px'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                borderBottom: '1px solid',
                borderColor: 'primary.mediumGray',
                pb: '16px'
              }}
            >
              <Typography
                variant="h4"
              >
                Family groups
              </Typography>
              <Typography variant="subText">
                Select family groups that you would not want to set for others to view.
              </Typography>
            </Box>
            <FamilyGroupCheckboxList />
          </Box> */}
          {/* <Box
            sx={{
              width: '100%',
              borderRadius: '8px',
              padding: '16px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              boxShadow: '0px 2px 10px 0px #5B87EF33',
              mt: '24px'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                borderBottom: '1px solid',
                borderColor: 'primary.mediumGray',
                pb: '16px'
              }}
            >
              <Typography
                variant="h4"
              >
                Your order history
              </Typography>
            </Box>
            <Box
              sx={{
                mt: '16px'
              }}
            >
              <Box
                sx={{
                  padding: '12px',
                  borderRadius: '5px',
                  bgcolor: 'primary.lightBlue'
                }}
              >
                <Typography variant="body">Available information</Typography>
              </Box>
            </Box>
          </Box> */}
        </Box>
        <Box
          sx={{
            padding: '16px',
            display: 'flex',
            justifyContent: 'space-between',
            borderTop: '1px solid',
            borderColor: 'primary.mediumGray'
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <BaseButton
                buttonType='default'
                sx={{
                  display: { xs: 'none', md: 'block' }
                }}
                onClick={onClose}
              >
                <Typography
                  variant="body"
                >
                  Cancel
                </Typography>
              </BaseButton>
            </Grid>
            <Grid item xs={12} md={6}>
              <BaseButton
                type="submit"
                buttonType='primary'
                loading={loading}
                disabled={Object.entries(errors).length !== 0}
              >
                <Typography
                  variant="body"
                  color='white'
                >
                  Save
                </Typography>
              </BaseButton>
            </Grid>
          </Grid>
        </Box>
      </form>
    </Box>
  )
}

export default ProfileEditForm